import {
  Box,
  Link,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from '@material-ui/core';
import { alpha, makeStyles, useTheme } from '@material-ui/core/styles';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import filesize from 'filesize';

import ButtonDownloadMidia from 'components/ButtonDownloadMidia';
import LegendaMensagem from 'components/LegendaMensagem';
import MessageBase, { MessageBaseProps } from 'components/MessageBase';

import MessageErrorFallback from './MessageErrorFallback';

type DocumentMessageProps = MessageBaseProps;

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    position: 'relative',
    minWidth: spacing(40),
  },
  listItem: {
    color: 'inherit',
    borderRadius: spacing(1),
  },
  titulo: {
    overflow: 'hidden',
    width: spacing(24),
  },
}));

export default function DocumentMessage(props: DocumentMessageProps) {
  const classes = useStyles();
  const { spacing, palette } = useTheme();

  try {
    const {
      mensagem: {
        id: mensagemId,
        midiaUrl,
        midiaDownloadErro,
        midiaTamanho,
        midiaTitulo,
        midiaFileName,
        atendimentoId,
        grupoChatId,
        baixando,
      },
    } = props;

    return (
      <MessageBase {...props}>
        <Box
          className={classes.root}
          style={{
            ...(!!midiaTitulo && {
              backgroundColor: alpha(palette.background.paper, 0.4),
              borderRadius: spacing(1),
              paddingInline: spacing(1),
            }),
          }}
        >
          <ListItem
            className={classes.listItem}
            title={`Baixar "${midiaFileName}"`}
            component={Link}
            target="_blank"
            rel="noopener noreferrer"
            href={midiaUrl}
            disabled={midiaDownloadErro || !midiaUrl}
            disableGutters
          >
            <ListItemAvatar>
              <InsertDriveFileIcon fontSize="large" color="inherit" />
            </ListItemAvatar>

            <ListItemText
              primary={midiaFileName}
              secondary={`Tamanho — ${filesize(midiaTamanho, {
                round: 0,
                locale: 'pt-BR',
              })}`}
              primaryTypographyProps={{
                noWrap: true,
                className: classes.titulo,
              }}
              secondaryTypographyProps={{
                variant: 'caption',
                color: 'inherit',
              }}
            />
          </ListItem>

          {midiaDownloadErro && (
            <Box ml={-1}>
              <ButtonDownloadMidia
                mensagemId={mensagemId}
                atendimentoId={atendimentoId}
                grupoChatId={grupoChatId}
                baixando={baixando}
              />
            </Box>
          )}
        </Box>

        <LegendaMensagem
          legenda={midiaTitulo}
          isMe={props?.fromMe}
          contatosMencionados={props.mensagem.contatosMencionados}
        />
      </MessageBase>
    );
  } catch (error) {
    return <MessageErrorFallback {...props} />;
  }
}
